<template>
<v-card flat small
  :style='dayEventStyle(event, events)'
  :class="[color, 'lighten-4']"
  class="px-1" >
    <small>
      <strong>{{ event.title || event.full_name }}</strong><br/>
      {{event.start}} - {{event.end}}
    </small>
</v-card>
</template>
<script>
export default {
  name: 'IntervalSlot',
  props: {
    event: { type: Object, required: true },
    events: { type: Array, required: true },
    color: { type: String },
    intervalHeight: { type: Number, default: 60 }
  },
  methods: {
    dayEventStyle (evt, evts) {
      let offset = 10
      let top = (evt.hour * this.intervalHeight) + evt.minute
      let width = null
      let left = 5
      let right = 5

      if (evt.index > 0) {
        let prev = evts[evt.index - 1]
        if (prev) {
          let hasExactOverlap = (evt.exactoverlaps && evt.exactoverlaps.length > 1)
          if (hasExactOverlap) {
            let overlapCount = evt.exactoverlaps.length
            width = (100 / overlapCount)
            evt.exactoverlaps.forEach((item, i) => {
              if (!item.left) {
                item.left = i
              }
            })
            left = (evt.left * width)
          } else {
            let hasOverlap = evt.interval.overlaps(prev.interval)
            if (hasOverlap) {
              left = prev.left + offset
              evt.left = left
            }
          }
        }
      }
      let style = {
        position: 'absolute',
        top: `${top}px`,
        height: `${evt.duration}px`,
        // width: `${width}%`,
        right: `${right}px`,
        left: `${left}%`,
        border: `solid 1px ${evt.color} !important`,
        lineHeight: 1,
        overflow: 'hidden'
      }
      if (width) { style['width'] = `${width}%` }
      return style
    }
  }
}
</script>



// WEBPACK FOOTER //
// IntervalSlot.vue?26c9951a